export const ALL_LANGUAGES = ["en", "de"] as const;
export const DEFAULT_LANGUAGE = "de";
